module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.108ac3f2.jpg";